import { Link } from "react-router-dom";
import { History } from "lucide-react";
import { useCart } from "../../context/CartContext";
import { imgUrl } from "../../lib/api";
import { BookToggle } from "../gallery/PhotoCard";

export const RecentlyViewed = ({ dark = true }) => {
  const { recent } = useCart();
  if (!Array.isArray(recent) || recent.length === 0) return null;
  const text = dark ? "text-[#FFF8EF]" : "text-[#240620]";
  return (
    <section className={`${dark ? "bg-[#190317]" : "bg-[#FFF8EF]"} py-10`} data-testid="recently-viewed">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
        <h2 className={`flex items-center gap-2 font-display text-3xl ${text}`}>
          <History size={22} className="text-[#D4AF37]" /> Recently viewed
        </h2>
        <div className="no-scrollbar -mx-5 mt-5 flex gap-4 overflow-x-auto px-5 pb-2 sm:mx-0 sm:px-0" data-lenis-prevent-wheel>
          {recent.map((p, i) => (
            <figure key={p.id} className="w-40 shrink-0 overflow-hidden rounded-2xl border border-[#D4AF37]/25 bg-[#330B2E] sm:w-48" data-testid={`recent-item-${i}`}>
              <Link to={`/c/${p.slug}?photo=${encodeURIComponent(p.id)}${p.page ? `&page=${p.page}` : ""}`} className="block aspect-[4/5] overflow-hidden">
                <img src={imgUrl(p.url)} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              </Link>
              <figcaption className="space-y-2 p-3">
                <p className="line-clamp-2 h-10 overflow-hidden text-xs font-medium leading-5 text-[#FFF8EF]">{p.title}</p>
                <BookToggle photo={p} catName={p.catName} slug={p.slug} testId={`recent-book-${i}`} />
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
